import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { DataTransferService } from '../../../../services/DataTransferService';



@Component({
    selector: 'receipts-product-type',
    templateUrl: './product-type.component.html',
    styleUrls: ['./product-type.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                opacity: 1,
                display: 'block'
            })),
            state('closed', style({
                opacity: 0,
                display: 'none'
            })),
            transition('open => closed', [
                animate('0.5s')
            ]),
            transition('closed => open', [
                animate('0.5s')
            ]),
        ]),
    ]
})
export class ProductTypeComponent implements OnInit, OnChanges, AfterViewInit {
  
    productType
    ngAfterViewInit(): void {
        this.data.currentProductTypeSource.subscribe(x => this.productType = x);
        if (this.productType != "default message" && this.productType != null) {
            this.selectProductType(this.productType);
            this.selectedProductType = this.productType;
        }
    }
    @Output() productTypeObject = new EventEmitter();
    @Input() changing: boolean;
    @Input() productTypes;
    @Input() enableChange;
    productTypeSelected: boolean;
    selectedProductType: string;
    isOpen: boolean = true;
    @Output() isEnableSelectShipper = new EventEmitter();

    constructor(private data: DataTransferService) {
        this.productTypeSelected = false;
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['changing'] != undefined) {
            var change = changes['changing'].currentValue
            if (change == true)
                this.isOpen = change;
        }
    }

    selectProductType(productTypeName) {
        this.productTypeObject.emit(productTypeName);
        this.isEnableSelectShipper.emit(true);
        this.productTypeSelected = true;
        this.selectedProductType = productTypeName.Code
        this.isOpen = !this.isOpen;
    }

    change() {
        this.isOpen = !this.isOpen;
        this.isEnableSelectShipper.emit(false);
    }

    ngOnInit() {
    }

}
